import React, { Component } from 'react';
import $ from 'jquery';
import Slider from "react-slick";
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import SliderIm1 from '../img/aboutpic1bw.jpg';
import SliderIm2 from '../img/aboutpic2bw.jpg';
import SliderIm3 from '../img/aboutpic3bw.jpg';
import SliderIm4 from '../img/aboutpic4bw.jpg';
import SliderIm5 from '../img/aboutpic5bw.jpg';
import SliderIm6 from '../img/aboutpic6bw.jpg';
import SliderIm7 from '../img/aboutpic7bw.jpg';
import SliderIm8 from '../img/aboutpic8bw.jpg';
import SliderIm9 from '../img/aboutpic9bw.jpg';
import SliderIm10 from '../img/aboutpic10bw.jpg';
import SliderIm11 from '../img/aboutpic11bw.jpg';
import SliderIm12 from '../img/aboutpic12bw.jpg';
import SliderIm13 from '../img/aboutpic13bw.jpg';
import SliderIm14 from '../img/aboutpic14bw.jpg';
import Helmet from 'react-helmet';



class SimpleSlider extends React.Component {
  render() {
    var settings = {
      infinite: true,
      slidesToShow: 1,
      fade: true,
      arrows :false,
      autoplay : true
    };
    return (
      <Slider {...settings} className="img-slider" id="abt-slider">
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm1})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm2})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm3})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm4})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm5})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm6})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm7})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm8})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm9})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm10})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm11})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm12})`}} >
            </div>
        </div>
        <div>
            <div className="item"  style={{backgroundImage: `url(${SliderIm13})`}} >
            </div>
        </div>
        
      </Slider>
    );
  }
}


class About extends Component {

    componentWillMount() {
        
        
    }
    componentDidMount(){
      
        }
	render() {
    return (
        <div>
        <Helmet
                title="About Us | RAT Films | Corporate Film Makers"
                meta={[
                  { name: 'description', content: "We bring together some of the best names in the business to deliver exceptional quality films." },
                  

                  ]}
              />
        
        <section className="page-section about ">
          <div className="container ">
            <div className="slider-section img-section" >
              <div className="img-slider" id="abt-slider">
                <SimpleSlider />
                
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <p className="heading">ABOUT</p>
                <h3 className="subheading"></h3>
              </div>
              <div className="col-sm-8 cntnt-half ">
                <p className="heading two">RAT Films</p>
                <p>Passion, Ingenuity and Quality is what makes us stand apart from the rest. At RAT Films we believe in magic of storytelling and compelling visuals. We believe even if its your tenth film for the same brand it needs to be distinctive, compelling and true. It should be that 'One Film' which works for the brand on all levels.</p>
                <p>RAT Films came into existence because of its commitment on delivering cutting edge films with hallmark of quality and film making passion. RAT films are true to its core.</p>
                <p>We bring together some of the best names in the business to deliver exceptional quality films. We offer complete Start to Finish Solutions.</p>
              </div>
            </div>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/about.js